import { useCallback } from 'react';

import { useValidateImage } from '@/hooks';
import { IMAGE_UPLOAD_CONSTANTS } from '@/views/build/constant';

export const useSearchedImageFile = () => {
  const validate = useValidateImage();

  const {
    ALLOWED_IMAGE_EXTENSIONS,
    MAX_IMAGE_DIMENSION,
    MAX_MB_SIZE,
    MAX_IMAGE_COUNT,
  } = IMAGE_UPLOAD_CONSTANTS;

  return useCallback(
    async (url: string) => {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const file = new File([blob], 'searched-image.jpg', {
          type: blob.type,
        });
        const isImageValid = await validate({
          file,
          validation: {
            mbSize: MAX_MB_SIZE,
            maxDimension: MAX_IMAGE_DIMENSION,
            extensions: ALLOWED_IMAGE_EXTENSIONS,
            countLimit: MAX_IMAGE_COUNT,
          },
        });

        if (!isImageValid) {
          return null;
        }
        return file;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    [
      validate,
      ALLOWED_IMAGE_EXTENSIONS,
      MAX_IMAGE_DIMENSION,
      MAX_MB_SIZE,
      MAX_IMAGE_COUNT,
    ],
  );
};
